import { unescape } from 'lodash'
import { formatRoute } from 'constants/urls'
import { replace } from 'redux-first-history'

import { BarError } from 'classes/errors'
import { MY_5_DYNAMICS } from 'urls'
import { notifyError } from 'app_modules/notifications/actions'
import * as sessionSelectors from 'app_modules/session/selectors'
import actionTypes from 'app_modules/session/constants'
import userActionTypes from 'app_modules/user/constants'
import api from 'api'

// Actions

export const fetchDocumentsFailure = error => ({
  payload: error,
  type: actionTypes.FETCH_DOCUMENTS_FAILURE,
})

export const fetchDocumentsRequest = () => ({
  type: actionTypes.FETCH_DOCUMENTS_REQUEST,
})

export const fetchDocumentsSuccess = response => ({
  payload: response,
  type: actionTypes.FETCH_DOCUMENTS_SUCCESS,
})

// Thunks

export const fetchDocuments = (options, onSuccess, onError) => {
  const thunk = (dispatch, getState) => {
    const accountId = sessionSelectors.accountId(getState())

    dispatch(fetchDocumentsRequest())

    const handleResponse = ({ documents, reEngagementSegment }) => {
      if (!documents) {
        dispatch(replace(formatRoute(MY_5_DYNAMICS, { accountId })))
        dispatch(notifyError(new BarError({ label: 'invalidAddress' })))
      } else {
        const unescapedDocuments = documents.map(document => ({
          ...document,
          content: unescape(document.content),
        }))

        dispatch(fetchDocumentsSuccess(unescapedDocuments))

        // Pair report endpoints return reEngagementSegment so the banner updates immediately
        // without requiring a re-login (BE updates the DB, FE syncs Redux in-session).
        if (reEngagementSegment !== undefined) {
          dispatch({ type: userActionTypes.UPDATE_CURRENT_PROFILE, payload: { reEngagementSegment } })
        }

        if (onSuccess) {
          onSuccess(unescapedDocuments)
        }
      }
    }

    const handleError = ({ error, isConnectionError }) => {
      dispatch(replace(formatRoute(MY_5_DYNAMICS, { accountId })))
      if (!isConnectionError) {
        dispatch(notifyError(new BarError({ ...error, label: 'invalidAddress' })))
      }
      dispatch(fetchDocumentsFailure(error))

      if (onError) {
        onError(error)
      } else {
        throw error
      }
    }

    return api.contentManager.getDocuments(
      {
        accountId,
        ...options,
      },
      handleResponse,
      handleError,
    )
  }

  thunk.type = actionTypes.FETCH_DOCUMENTS

  return thunk
}

export default fetchDocuments
